module.exports = __webpack_public_path__ + "c83c03c30958a3425be218280f0594d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_45.jpg
// module id = 1747
// module chunks = 5